<template>
  <div class="information-panel">
    <div class="information-panel__logo">
      <component :is="logoLight" />
    </div>
    <div class="information-panel__about">
      <div class="information-panel__about-info">
        <span class="information-panel__about-info-header">
          {{ tt('infrastructure.description.aboutCompanyTitle') }}
        </span>
        <span class="information-panel__about-info-description">
          {{ tt('infrastructure.description.aboutCompanyDescription') }}
        </span>
      </div>
      <SupportBlock />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import tt from '@/i18n/utils/translateText';
import TruckerTmsLightSvg from '@/assets/svg/logo/trucker-tms-light.svg';
import ItiLightSvg from '@/assets/svg/logo/iti-light.svg';
import useAppTheme from '@/composables/application/useAppTheme';
import { EAppLogoNames } from '@/components/AppLogo/constants';
import { toPascalCase } from '@/utils';

import SupportBlock from '../SupportBlock/index.vue';

export default defineComponent({
  name: 'InformationPanel',
  components: {
    SupportBlock,
    TruckerTmsLightSvg,
    ItiLightSvg,
  },
  setup() {
    const { getThemeConfig } = useAppTheme();
    const { icons } = getThemeConfig();

    const logoLight = computed(() => {
      const currentAppLogoName = Object.values(EAppLogoNames).find((logoName: string) => logoName === icons.logoLight) || '';

      if (currentAppLogoName) {
        return `${toPascalCase(currentAppLogoName)}Svg`;
      }

      return `${toPascalCase(EAppLogoNames.truckerTmsLight)}Svg`;
    });

    return {
      logoLight,

      tt,
    };
  },
});
</script>

<style lang="scss" src="./styles.scss" />
